<figure class="quote" *ngFor="let quote of [randomQuote]">
  <blockquote>
    {{ quote.text }}
  </blockquote>
  <figcaption>&mdash; {{ quote.author }}, <cite>BrainyQuote</cite></figcaption>
</figure>
